import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import trackResourceLinkClick from '../../analytics/JurisdictionAnalytics';
import { JurisdictionAPI } from '../../api';
import { State } from '../../dux/@types';
import STATES from '../../helpers/states';
import './Jurisdictions.scss';
import { SEOHead } from '../../components/head/SEOHead';

type JurisdictionResourcesProps = {
  jurisAbbr: string;
};

const JurisdictionResources = (props: JurisdictionResourcesProps): ReactElement => {
  const { jurisAbbr } = props;
  const organizationUser = useSelector(
    (state: State) => state.account.organizationUser,
  );
  const {
    data: jurisReferenceInfo,
    isFetching,
    isError,
  } = JurisdictionAPI.endpoints.getReferenceInfo.useQuery(jurisAbbr);
  const stateName = STATES[jurisAbbr.toUpperCase()];

  const renderCategoryLinks = (category: string): ReactElement => {
    if (isFetching) {
      return <span>Loading reference links...</span>;
    }
    if (isError) {
      return <span>Error loading reference links!</span>;
    }
    if (jurisReferenceInfo && jurisReferenceInfo.links.length > 0) {
      return (
        <div className="reference-links">
          <SEOHead
            description={`Additional resources about the legislative process in ${stateName}`}
            title={`${stateName} Resources`}
          />
          {jurisReferenceInfo.links
            .filter((l) => l.category.toLowerCase() === category.toLowerCase())
            .map((link) => (
              <a
                className="reference-link"
                href={link.url}
                key={link.id}
                onClick={() => {
                  trackResourceLinkClick(
                    jurisReferenceInfo.jurisdictionAbbr,
                    link.category,
                    link.url,
                    'Jurisdiction Details',
                    organizationUser,
                  );
                }}
                rel="noopener noreferrer"
                target="_blank"
              >
                <div className="link-wrapper">
                  <span>{stateName}</span>
                  <strong>{link.title}</strong>
                  <p>{link.description}</p>
                </div>
                <div className="view-more">View more</div>
              </a>
            ))}
        </div>
      );
    }
    return <></>;
  };
  return (
    <div className="resources-tab">
      <h2>Legislative</h2>
      <p>
        Below you can find resources related to this jurisdiction’s legislative
        information.
      </p>
      {renderCategoryLinks('legislative')}
      <hr />
      <h2>Regulatory</h2>
      <p>
        Below you can find resources related to this jurisdiction’s regulatory
        information.
      </p>
      {renderCategoryLinks('regulatory')}
    </div>
  );
};

export default JurisdictionResources;
